module.exports = __webpack_public_path__ + "static/img/Jack-Cole.cda72ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Cole.jpg
// module id = vaR3
// module chunks = 0